import React from 'react';

const Mission = () => {
  return (
    <section className="section">
      <div className="container mission-grid">
        <div>
          <span className="section-kicker">Notre mission</span>
          <h2 className="section-title">
            Éclairer la décision économique par la connaissance stratégique
          </h2>
          <p className="section-lead" style={{ marginBottom: '24px' }}>
            L'AEII produit et diffuse des travaux de recherche rigoureux au service
            des institutions publiques, des entreprises et des chercheurs engagés
            dans le développement économique du continent africain.
          </p>

          <div className="pillar-list">
            <div className="pillar-item">
              <div className="pillar-icon">
                <i className="fa-solid fa-magnifying-glass-chart"></i>
              </div>
              <div>
                <h4>Intelligence économique</h4>
                <p>Veille stratégique, analyse concurrentielle et anticipation des risques économiques.</p>
              </div>
            </div>
            <div className="pillar-item">
              <div className="pillar-icon">
                <i className="fa-solid fa-book-open-reader"></i>
              </div>
              <div>
                <h4>Recherche &amp; publication scientifique</h4>
                <p>Production de rapports, études et articles scientifiques évalués par des pairs.</p>
              </div>
            </div>
            <div className="pillar-item">
              <div className="pillar-icon">
                <i className="fa-solid fa-people-group"></i>
              </div>
              <div>
                <h4>Valorisation des connaissances</h4>
                <p>Diffusion des savoirs stratégiques auprès des décideurs et de la société civile.</p>
              </div>
            </div>
          </div>
        </div>

        <img src="/images/about-team.jpg" alt="Équipe de recherche AEII" loading="lazy" />
      </div>
    </section>
  );
};

export default Mission;